import Swiper from 'swiper'
import { Pagination, Navigation } from 'swiper/modules'
import { swiperEvents } from '../../swiper/swiperEvents'

Swiper.use([Navigation, Pagination])

const breakpointMin768 = window.matchMedia('(min-width:768px)')
const breakpoinMax1024 = window.matchMedia('(max-width:1023px)')
const breakpoinMin1550 = window.matchMedia('(min-width:1550px)')

const careImportantSwiperFromMarkup = document.querySelector(
  '[data-why-important-section-swiper]',
)
let careImportantSwiper
const enableCareImportantSwiper = function () {
  careImportantSwiper = new Swiper('[data-why-important-section-swiper]', {
    observer: true,
    pagination: {
      el: '[data-why-important-section-pagination]',
      type: 'progressbar',
    },
    navigation: {
      nextEl: '[data-why-important-section-next]',
      prevEl: '[data-why-important-section-prev]',
    },

    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
    },
    on: swiperEvents,
  })
}

const breakpointCheckerForCareImportantSwiper = function () {
  if (breakpoinMax1024.matches === false) {
    if (careImportantSwiper !== undefined) {
      careImportantSwiper.destroy()
    }
    return
  } else if (breakpoinMax1024.matches === true) {
    return enableCareImportantSwiper()
  }
}

if (careImportantSwiperFromMarkup) {
  // keep an eye on viewport size changes
  breakpoinMax1024.addEventListener('change', breakpointCheckerForCareImportantSwiper)
  //

  breakpointCheckerForCareImportantSwiper()
}

//  careForYouSwiper
const careForYouSwiperFromMarkup = document.querySelector('[data-for-you-section-swiper]')
export let careForYouSwiper

const enableCareSwiper = function () {
  careForYouSwiper = new Swiper('[data-for-you-section-swiper]', {
    slidesPerView: 'auto',
    observer: true,
    pagination: {
      el: '[data-for-you-section-pagination]',
      type: 'progressbar',
    },
    navigation: {
      nextEl: '[data-for-you-section-next]',
      prevEl: '[data-for-you-section-prev]',
    },
    on: swiperEvents,
  })
}

const breakpointCheckerForCareSwiper = function () {
  if (breakpointMin768.matches === false || breakpoinMin1550.matches === true) {
    if (careForYouSwiper !== undefined) {
      careForYouSwiper.destroy(true, true)
    }
    return
  } else if (breakpointMin768.matches === true) {
    return enableCareSwiper()
  }
}

if (careForYouSwiperFromMarkup) {
  // keep an eye on viewport size changes
  breakpointMin768.addEventListener('change', breakpointCheckerForCareSwiper)
  breakpoinMin1550.addEventListener('change', breakpointCheckerForCareSwiper)

  // kickstart

  breakpointCheckerForCareSwiper()
}

// // careForYouSwiper end
